import { sharedWorkerActions, sharedWorker } from 'workers/sharedWorker/utils/utils';
import { PROFILE } from 'config';
import { store } from 'store/store';
import { generalActions } from 'store/generalSlice/generalSlice';
import { endActivityPeriodsAndBeacon } from 'services/activityTracking/lifecycle';
import { ACTIVITY_END_REASON } from 'utils/activityTracking/constants';
// import { transactionActions } from 'store/transactionsSlice/transactionsSlice';

export const beforeUnloadHandler = () => {
    // BEAST-13036: the trailing activity flush goes first, because there is no retry on an
    // unloading page and later work here can be cut short. `endActivityPeriodsAndBeacon` is
    // internally guarded, but it is wrapped again here so that telemetry can never, under any
    // failure, skip the shared-worker cleanup and the cookie reset below.
    try {
        endActivityPeriodsAndBeacon(ACTIVITY_END_REASON.PAGE_UNLOAD);
    } catch (error) {
        console.warn('activityTracking: unload flush failed.', error);
    }
    sharedWorkerActions.removeWindow({ id: sharedWorker.id });
    store.dispatch(generalActions.setIsWindowDisconnectedFromSharedWorker(true));
    setCookie();
};

function setCookie() {
    switch (PROFILE) {
        case 'development':
            document.cookie = 'aiqD=AlertsON; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            break;
        case 'staging':
            document.cookie = 'aiqS=AlertsON; path=/; domain=.birdseyesecurity.com; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            break;
        case 'production':
            document.cookie = 'aiqP=AlertsON; path=/; domain=.birdseyesecurity.com; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            break;
        default:
            document.cookie = 'aiq=AlertsON; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
}
